<div class="card-single" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="pane-header" [class.mobile]="deviceService.isMobile()">
  <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
    <ng-container side>
      <span class="content-type normal">{{ contentTypeTitle | customLocale }}</span>
    </ng-container>
  </app-library-title>
  <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
  </div>
  <div class="card-wrap">
    <app-content-card [item_id]="item_id"></app-content-card>
  </div>
</ng-template>
